
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";


import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);

const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

  const[nauto,setnAuto]=useState("None");
  const[nauto1,setnAuto1]=useState("None");
  const[nauto2,setnAuto2]=useState("None");
  const[nauto3,setnAuto3]=useState("None");
  const[nauto4,setnAuto4]=useState("None");
  const[nauto5,setnAuto5]=useState("None");
  const[nauto6,setnAuto6]=useState("None");
const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x44c854371a0367350a2b2c417a33c98f4962afea";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0xE2767A23D4f40C7F832F1E5C8010C4cCF0D6bB4C";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Upgrade USDT 50";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const auto7 = Number(alltasks1[0]) - 1;
setAuto7(auto7);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[22])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[23])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[11])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[12])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[13])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[14])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[16])/1000000000000000000;
         setAuto6(auto6);
        

         const nauto = Number(alltasks[14])/1000000000000000000;
         setnAuto(nauto);
         const nauto1 = Number(alltasks[15])/1000000000000000000;
         setnAuto1(nauto1);
         const nauto2 = Number(alltasks[24])/1000000000000000000;
         setnAuto2(nauto2);
         const nauto3 = Number(alltasks[25])/1000000000000000000;
         setnAuto3(nauto3);
         const nauto4 = Number(alltasks[26])/1000000000000000000;
         setnAuto4(nauto4);
         const nauto5 = Number(alltasks[27])/1000000000000000000;
         setnAuto5(nauto5);
         

         
         
         
         
         
         const bonus = Number(alltasks[18]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[19]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[6]);
         document.querySelector("#pp").value  = Number(alltasks[6]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://bvtpro.pro/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    if(pack==50)
    { 
      document.querySelector("#test").value = "Upgrade USDT 100";
    
    }
    else if(pack==150)
    { 
      document.querySelector("#test").value = "Upgrade USDT 150";
    
    }
    else if(pack ==300)
    {
      document.querySelector("#test").value = "Upgrade USDT 250";
    }
    else if(pack ==550)
    {
      
      document.querySelector("#test").value = "Upgrade USDT 500";
    }
    else if(pack ==1050)
    {
      document.querySelector("#test").value = "Upgrade USDT 1000";
    }
    
    else if(pack ==2050)
    {
      document.querySelector("#test").value = "Upgrade USDT 2000";
    }
    else if(pack ==4050)
    {
      document.querySelector("#test").value = "Upgrade USDT 4000";
    }
    else if(pack ==8050)
    {
    
      document.querySelector("#test").value = "All Packages Purchased";
    }
    
    console.log(pack);
   
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <section className="section royalty" id="royalty">
  <div className="container">
   

    <h2 className="section-title">Dashboard</h2>

    <div className="royalty-grid">
       <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title"><input type ="text" style={{color:"white" ,backgroundColor:"#0a1628", textAlign:"center", border :"0",padding:"0.8rem" ,width:"75%"} }id ="test"></input></div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
          <Buy state={state} />
        </span>

        <p className="rcard-req">
         
        </p>
      </div>

      <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Total Joinings</div>

        <span className="rcard-pct">{auto7} </span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">My Total Packages</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
           USDT {pack}  
        </span>

        <p className="rcard-req">
         
        </p>
      </div>

       <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">My Direct Income</div>

        <span className="rcard-pct">USDT {directs}</span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">My Direct Team</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
         {direct}
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Total Income</div>

        <span className="rcard-pct"> USDT {level}</span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">level - I Income</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
         USDT {auto}
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
      <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - II Income</div>

        <span className="rcard-pct">USDT {auto1}</span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">Level - III Income</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
           USDT {auto2}
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
  <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Level - IV Income</div>

        <span className="rcard-pct"
        >USDT {auto3}</span>

        <p className="rcard-req">
        
        </p>
      </div>
        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - V Income</div>

        <span className="rcard-pct"  style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}>USDT {nauto}</span>

        <p className="rcard-req">
        
        </p>
      </div>

        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - VI Income</div>

        <span className="rcard-pct">USDT {nauto1}</span>

        <p className="rcard-req">
        
        </p>
      </div>

        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - VII Income</div>

        <span className="rcard-pct"
         style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}>USDT {nauto2}</span>

        <p className="rcard-req">
        
        </p>
      </div>
        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - VIII Income</div>

        <span className="rcard-pct">USDT {nauto3}</span>

        <p className="rcard-req">
        
        </p>
      </div>
        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title" >level - IX Income</div>

        <span className="rcard-pct"  style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}>USDT {nauto4}</span>

        <p className="rcard-req">
        
        </p>
      </div>
        <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">level - X Income</div>

        <span className="rcard-pct">USDT {nauto5}</span>

        <p className="rcard-req">
        
        </p>
      </div>
      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">Silver Royalty</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
          USDT {auto5}
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
  <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Single Leg Income</div>

        <span className="rcard-pct">USDT {auto6}</span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">Current Week Direct</div>

        <span
          className="rcard-pct"
          style={{
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}
        >
           {bonus}
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
  <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Current Week Team</div>

        <span className="rcard-pct">{bonus1}</span>

        <p className="rcard-req">
        
        </p>
      </div>

     
  <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">Welcome To Global Block Wealth :</div>

        <span style={{wordBreak:"break-all",fontSize:"0.8rem" ,  
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }}className="rcard-pct">Connected Account: {account}</span>

        <p className="rcard-req">
        
        </p>
      </div>

      <div
        className="rcard gcard "
        style={{ transitionDelay: "0.1s" }}
      >
        <span className="rcard-gem">🪙</span>

        <div className="rcard-title">Refer Link</div>

        <span
          className="rcard-pct"
          style={{
           
            fontSize:"0.8rem",
            wordBreak:"break-all"
          }}
        >
         {referlink}<button><img
  src="copy.png"
  alt="Copy"
  style={{
    height: "50px",
    width: "50px",
  }}
  onClick={() => navigator.clipboard.writeText(referlink)}
/></button>
        </span>

        <p className="rcard-req">
         
        </p>
      </div>
  <div className="rcard gcard ">
        <span className="rcard-gem">💵</span>
        <div className="rcard-title">My Refer :</div>

        <span style={{fontSize:"0.8rem",
            color: "#ffd700",
            textShadow: "0 0 24px rgba(255, 200, 0, 0.4)",
          }} className="rcard-pct">{refer}</span>

        <p className="rcard-req">
        
        </p>
      </div>

    

    </div>
  </div>
</section>
                       
    </div>                      
  
  );
}

export default App;
